export enum HttpErrorType {
    Aborted = 'aborted',
    UnknownError = 'unknown_error',
}
